import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/etherscan-logo-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-24f04350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accounting-transaction-table" }
const _hoisted_2 = { class: "mark" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Orders", -1))
const _hoisted_4 = { class: "csv" }
const _hoisted_5 = {
  class: "table",
  cellpadding: "0",
  cellspacing: "0",
  border: "0"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Order", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Member", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Products", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "center" }, "Wallet Address", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-header" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Expected")
  ])
], -1))
const _hoisted_11 = { class: "right" }
const _hoisted_12 = { class: "col-header" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Received", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Referred By", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"margin-bottom":"5px"} }
const _hoisted_17 = { class: "member-name" }
const _hoisted_18 = { class: "product-name" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "node-badges"
}
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "center" }
const _hoisted_23 = { class: "address-options" }
const _hoisted_24 = { class: "address" }
const _hoisted_25 = { class: "address-copy-area" }
const _hoisted_26 = {
  key: 0,
  class: "copied-msg"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "etherscan-logo",
  src: _imports_0
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "right" }
const _hoisted_31 = { class: "right" }
const _hoisted_32 = { class: "received" }
const _hoisted_33 = { class: "amount" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "member-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_svg = _resolveComponent("ui-svg")!
  const _component_ui_icon_button = _resolveComponent("ui-icon-button")!
  const _component_ui_placeholder = _resolveComponent("ui-placeholder")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "top",
        style: _normalizeStyle(_ctx.headerStyle)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ui_svg, { src: _ctx.logoMark }, null, 8, ["src"])
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadCSV()))
          }, "Download CSV")
        ])
      ], 4),
      _createElementVNode("table", _hoisted_5, [
        _withDirectives(_createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("td", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_ui_icon_button, {
                  icon: "switch",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleCurrency()))
                }),
                _hoisted_13
              ])
            ]),
            _hoisted_14
          ])
        ], 512), [
          [_vShow, _ctx.ready]
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: order.id,
              onClick: ($event: any) => (_ctx.selectRow(order)),
              class: _normalizeClass({ 'selected': order === _ctx.selectedOrder})
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("strong", null, _toDisplayString(order.orderNumber), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(order.createdAt)) + " " + _toDisplayString(_ctx.formatTime(order.createdAt)), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(order.customerName), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(order.email), 1),
                _createElementVNode("div", null, "ID: " + _toDisplayString(order.userId), 1)
              ]),
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.itemId
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createTextVNode(_toDisplayString(item.productName) + " ", 1),
                      false
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "(" + _toDisplayString(item.unitPrice) + " " + _toDisplayString(item.unitPriceSymbol) + ")", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" x " + _toDisplayString(item.quantity), 1)
                    ])
                  ]))
                }), 128)),
                (order.nodes && order.nodes.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.nodes, (nodeId) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: nodeId,
                          class: "node-badge",
                          title: _ctx.nodeNameForId(nodeId),
                          style: _normalizeStyle(_ctx.nodeBadgeStyle(nodeId))
                        }, _toDisplayString(_ctx.nodeAbbreviationForId(nodeId)), 13, _hoisted_21))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.shortAddress(order.paymentSummary.address)), 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_ui_icon_button, {
                      icon: "hi-clipboard",
                      onClick: ($event: any) => (_ctx.copyAddressToClipboard(order))
                    }, null, 8, ["onClick"]),
                    (_ctx.copiedMessageOrderId === order.key)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Address Copied!"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "etherscan-button",
                    onClick: ($event: any) => (_ctx.openAddressForOrder(order))
                  }, _hoisted_29, 8, _hoisted_27)
                ])
              ]),
              _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.getInvoiceValueFormatted(order)), 1),
              _createElementVNode("td", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.getReceivedValueFormatted(order)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["status", _ctx.statusClassForOrder(order)])
                  }, [
                    _createVNode(_component_ui_icon_button, {
                      icon: _ctx.statusIconForOrder(order)
                    }, null, 8, ["icon"])
                  ], 2)
                ])
              ]),
              _createElementVNode("td", null, [
                (order.sponsor)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(order.sponsor.name), 1),
                      _createElementVNode("div", null, _toDisplayString(order.sponsor.email), 1),
                      _createElementVNode("div", null, "ID: " + _toDisplayString(order.sponsor.id), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_15))
          }), 128))
        ])
      ])
    ]),
    (!_ctx.ready)
      ? (_openBlock(), _createBlock(_component_ui_placeholder, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}